// extracted by mini-css-extract-plugin
export default {"loader":"Loader_loader__NjMTy","spin":"Loader_spin__NWeF3"};